// Feature flags for web-app. There is no runtime flag service in this
// repo — flags are build-time VITE_APP_* env values, the same pattern
// already used elsewhere (VITE_APP_ONBOARDING, VITE_APP_MARKETPLACE_SETTINGS).
//
// VITE_APP_RESERVATION_V2_ENABLED is the single switch between the v1
// (Order-centric) and v2 (Reservation-centric) admin reservation flows —
// see api's /reservation/* (v1) vs /admin/v2/reservations/* (v2) routes.
// api serves both at all times; this flag is the only thing that decides
// which one the console calls.
export const isReservationV2Enabled = () =>
  import.meta.env.VITE_APP_RESERVATION_V2_ENABLED === "true";
